import { MutationTree } from 'vuex';
import { REGLES_GESTION } from './mutation-types';
import { persisterActif, ReglesGestionState } from './state';

export const mutations: MutationTree<ReglesGestionState> = {
    [REGLES_GESTION.SET_ACTIF](state, actif: boolean) {
        state.actif = actif;
        if (!actif) {
            state.panneauOuvert = false;
        }
        persisterActif(actif);
    },
    [REGLES_GESTION.SET_PANNEAU_OUVERT](state, ouvert: boolean) {
        state.panneauOuvert = ouvert;
    },
    [REGLES_GESTION.SET_CLE_MISE_EN_AVANT](state, cle: string | null) {
        state.cleMiseEnAvant = cle;
    },
};
